define([
    "./gatewayModule",
    "./gatewayRouter",
    "./gatewayService",
    "./integration/gatewayIntegration",
], function () {
});